module.exports = __webpack_public_path__ + "img/6N.004d9c76.png";